<div class="container-404">
    <div class="div">
        <img src="assets/static/logo/error-404.png" alt="Error">
    </div>
    <br>
    <br>
    <a href="/">Back to Home</a>
</div>
